import { createContext, useContext } from "@wordpress/element";
import PropTypes from "prop-types";

export const ProductImageContext = createContext({});
export const useProductImageContext = () => useContext(ProductImageContext);

export const ProductImageContextProvider = ({ productImage, children }) => {
	const contextValue = {
		productImage,
	};
	return (
		<ProductImageContext.Provider value={contextValue}>
			{children}
		</ProductImageContext.Provider>
	);
};

ProductImageContextProvider.propTypes = {
	children: PropTypes.node,
	productImage: PropTypes.object,
};
